module.exports = __webpack_public_path__ + "img/5.cdfbeb92.jpg";